import React from 'react';
import './AuthModal.css';

const AuthModal = ({
  isOpen,
  emailConfigured,
  googleConfigured,
  step,
  email,
  code,
  loading,
  errorMessage,
  onClose,
  onEmailChange,
  onCodeChange,
  onSendCode,
  onVerifyCode,
  onResendCode,
  onBack,
  onGoogleSignIn
}) => {
  if (!isOpen) {
    return null;
  }

  const isEmailStep = step === 'email';

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal-content">
        <h3>Sign in to use AI Zoom</h3>
        <p>We email a short code. No password.</p>
        {!emailConfigured && (
          <p className="auth-modal-warning">Email sign-in is not configured yet.</p>
        )}
        {errorMessage && <p className="auth-modal-error">{errorMessage}</p>}
        <div className="auth-modal-form">
          {isEmailStep ? (
            <>
              <label className="auth-modal-label" htmlFor="auth-email">
                Email
              </label>
              <input
                id="auth-email"
                className="auth-modal-input"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(event) => onEmailChange(event.target.value)}
                autoComplete="email"
                disabled={!emailConfigured || loading}
              />
              <button
                className="auth-modal-button primary"
                onClick={onSendCode}
                disabled={!emailConfigured || loading || !email}
              >
                {loading ? 'Sending...' : 'Send code'}
              </button>
            </>
          ) : (
            <>
              <p className="auth-modal-hint">Code sent to {email}</p>
              <label className="auth-modal-label" htmlFor="auth-code">
                Code
              </label>
              <input
                id="auth-code"
                className="auth-modal-input"
                type="text"
                inputMode="numeric"
                placeholder="123456"
                value={code}
                onChange={(event) => onCodeChange(event.target.value)}
                autoComplete="one-time-code"
                disabled={loading}
              />
              <button
                className="auth-modal-button primary"
                onClick={onVerifyCode}
                disabled={loading || !code}
              >
                {loading ? 'Verifying...' : 'Verify code'}
              </button>
              <div className="auth-modal-row">
                <button
                  className="auth-modal-button ghost"
                  onClick={onResendCode}
                  disabled={loading}
                >
                  Resend code
                </button>
                <button className="auth-modal-button ghost" onClick={onBack} disabled={loading}>
                  Use different email
                </button>
              </div>
            </>
          )}
        </div>
        <div className="auth-modal-divider">
          <span>or</span>
        </div>
        <div className="auth-modal-actions">
          <button
            className="auth-modal-button"
            onClick={onGoogleSignIn}
            disabled={!googleConfigured || loading}
          >
            Continue with Google
          </button>
          <button className="auth-modal-button ghost" onClick={onClose}>
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
